export const WEB_APP_ORGANIZATION_KEYS = {
  NAME: 'name',
  PREFIX: 'prefix',
  ID: 'id',
  COLOR: 'color',
  EXTERNAL_ID: 'externalId'
}
